import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { FolderType } from '../../redux/types';
import s from './FolderTabs.scss';
export var FolderTabs = function (_a) {
    var selectedSubmissionType = _a.selectedSubmissionType, onSubmissionTypeSelected = _a.onSubmissionTypeSelected;
    var t = useTranslation().t;
    return (React.createElement("div", { className: s['tabs'] }, [FolderType.Gallery, FolderType.Collection].map(function (type) { return (React.createElement("button", { key: type, className: classnames(s['tab-button'], selectedSubmissionType === type && s['active']), onClick: function () { return onSubmissionTypeSelected(type); } }, t("addToGroup.folderType." + type))); })));
};
FolderTabs.displayName = 'FolderTabs';
export default FolderTabs;
//# sourceMappingURL=FolderTabs.js.map